// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.container__Users_2b3qp .select-filter__Users_2LA0A {\n  padding: 0;\n}\n.container__Users_2b3qp .input-container__Users_fin-M {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.rule-title__Users_vvkTz {\n  padding-top: 10px;\n  margin-bottom: 10px;\n  border-top: 1px solid;\n  border-image: linear-gradient(90deg, rgba(128, 128, 128, 0.1), rgba(0, 0, 0, 0.6), rgba(128, 128, 128, 0.1)) 1;\n}\n.rule-title__Users_vvkTz:first-of-type {\n  border-top: 0;\n}\n.buttons__Users_ybbMv {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "container__Users_2b3qp",
	"select-filter": "select-filter__Users_2LA0A",
	"selectFilter": "select-filter__Users_2LA0A",
	"input-container": "input-container__Users_fin-M",
	"inputContainer": "input-container__Users_fin-M",
	"rule-title": "rule-title__Users_vvkTz",
	"ruleTitle": "rule-title__Users_vvkTz",
	"buttons": "buttons__Users_ybbMv"
};
module.exports = exports;
